"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var CheckboxPart_1;
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckboxPart = void 0;
const T = __importStar(require("@microsoft/fast-element"));
require("./template.html");
const client_1 = require("@rws-framework/client");
const _part_includes_1 = require("../_part_includes");
//@ts-ignore                
let rwsTemplate = T.html `<div class="form-group${x => x.inline ? ' inline' : ''}${x => x.grid ? ' grid' : ''}">
    ${T.when(x => !x.multiple, T.html `
        <div class="form-check">
            <input 
                type="checkbox"
                name="${x => x.name}"
                class="form-check-input${x => x.label ? '' : ' no-label'}"
                @change="${(x, c) => x.handleChange(c.event)}"
                ?checked="${x => !!x.value}"
                style="--checkbox_size: ${x => x.size ? x.size + 'px' : 'inherit'}"
            />
            ${T.when(x => x.label, T.html `<label class="form-check-label">${x => x.label.t()}</label>`)}
            <slot name="info"></slot>
        </div>
    `)}
    
    ${T.when(x => x.multiple, T.html `
        <div class="multiple-checkboxes">
            ${T.when(x => x.label, T.html `<label class="form-label">${x => x.label.t()}</label>`)}
            <slot name="info"></slot>
            <div class="checkbox-group${x => x.horizontal === 'true' ? ' horizontal' : ''}">
                ${T.repeat(x => x.options || [], T.html `
                    <div class="form-check" @click="${(x, c) => c.parent.handleContainerClick(c.event, x.value)}">
                        <input 
                            type="checkbox"
                            name="${(x, c) => c.parent.name}"
                            value="${x => x.value}"
                            class="form-check-input"
                            @change="${(x, c) => c.parent.handleChange(c.event)}"
                            ?checked="${(x, c) => c.parent.isChecked(x.value)}"
                            style="--checkbox_size: ${(x, c) => c.parent.size ? c.parent.size + 'px' : 'inherit'}"
                        />
                        <label class="form-check-label">${x => x.label.t()}</label>
                    </div>
                `)}
            </div>
        </div>
    `)}
</div>
`;
require("./styles/layout.scss");
const styles = T.css `:host-context(.force-placeholder) input::placeholder,
select::placeholder,
textarea::placeholder {
  opacity: 1 !important;
}

input {
  width: var(--checkbox_size, inherit);
  height: var(--checkbox_size, inherit);
}

:host-context(.static) input {
  position: static !important;
}

:host-context([inline=true]) {
  display: inline-block;
}
:host-context([inline=true]) .inline {
  display: inline-block;
}
:host-context([inline=true]) .inline .form-check-input {
  position: static;
}

.no-label {
  margin-left: 0;
}

.form-group > .form-label {
  display: block;
  margin-bottom: 0.5rem;
  font-size: 0.92rem;
  font-weight: 700;
}

.checkbox-group .form-check input {
  margin-left: 0;
  margin-right: 0;
  position: static;
}

.multiple-checkboxes .form-label {
  font-weight: 700;
  margin-bottom: 0.5rem;
  display: block;
}
.multiple-checkboxes .checkbox-group.horizontal {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
}
.multiple-checkboxes .checkbox-group .form-check {
  display: flex;
  align-items: center;
  margin-bottom: 0.5rem;
}
.multiple-checkboxes .checkbox-group .form-check input {
  margin-right: 0;
}
.multiple-checkboxes .checkbox-group .form-check label {
  margin-bottom: 0;
  cursor: pointer;
}

.form-group.grid .checkbox-group {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
  gap: 2px 12px;
}

.form-group.inline .checkbox-group {
  flex-direction: row;
  flex-wrap: wrap;
  gap: 8px;
}`;
const shadowOptions = { "mode": "open" };
let CheckboxPart = CheckboxPart_1 = class CheckboxPart extends client_1.RWSViewComponent {
    constructor() {
        super(...arguments);
        this.horizontal = 'false';
        this.ignored = 'false';
        this.dontEmit = false;
        this.inline = false;
        this.grid = false;
        this.hoverevent = false;
        this.selectedValues = [];
        this.handleContainerClick = (event, value) => {
            var _a;
            const target = event.target;
            if (target.tagName === 'INPUT') {
                return true;
            }
            event.preventDefault();
            const checkbox = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector(`input[type="checkbox"][value="${CSS.escape(value)}"]`);
            if (!checkbox) {
                return;
            }
            checkbox.checked = !checkbox.checked;
            checkbox.dispatchEvent(new Event('change', { bubbles: true }));
        };
        this.handleChange = (event) => {
            const target = event.target;
            if (this.multiple) {
                const value = target.value;
                if (target.checked) {
                    if (!this.selectedValues.includes(value)) {
                        this.selectedValues = [...this.selectedValues, value];
                    }
                }
                else {
                    this.selectedValues = this.selectedValues.filter(v => v !== value);
                }
                // Update the array value for form handling
                this.value = this.selectedValues;
                // Trigger custom change event for multiple checkboxes like tags component does
                this.triggerChangeEvent();
            }
            else {
                // Single checkbox - use standard handling
                _part_includes_1.handlePartChange.call(this, event);
            }
        };
        this.handleOptionHover = (event) => {
            const target = event.target;
            const formCheck = target.closest('.form-check');
            if (!formCheck || formCheck.contains(event.relatedTarget)) {
                return;
            }
            const input = formCheck.querySelector('input[type="checkbox"]');
            if (!input) {
                return;
            }
            const option = (this.options || []).find((opt) => String(opt.value) === String(input.value));
            if (!option) {
                return;
            }
            this.$emit('form-part:option:hover', {
                info: option.info,
                label: option.label,
                value: option.value,
                name: this.name,
                formPartType: CheckboxPart_1.PART_TYPE
            });
        };
        this.handleOptionUnhover = (event) => {
            const target = event.target;
            const formCheck = target.closest('.form-check');
            if (!formCheck || formCheck.contains(event.relatedTarget)) {
                return;
            }
            const input = formCheck.querySelector('input[type="checkbox"]');
            if (!input) {
                return;
            }
            const option = (this.options || []).find((opt) => String(opt.value) === String(input.value));
            if (!option) {
                return;
            }
            this.$emit('form-part:option:unhover', {
                info: option.info,
                label: option.label,
                value: option.value,
                name: this.name,
                formPartType: CheckboxPart_1.PART_TYPE
            });
        };
    }
    optionsChanged(oldOptions, newOptions) {
        if (this.multiple && newOptions && newOptions.length > 0) {
            // When options are loaded, update checkbox states
            setTimeout(() => {
                this.updateCheckboxStates();
            }, 50);
        }
    }
    connectedCallback() {
        var _a, _b;
        super.connectedCallback();
        if (this.hoverevent) {
            (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.addEventListener('mouseover', this.handleOptionHover);
            (_b = this.shadowRoot) === null || _b === void 0 ? void 0 : _b.addEventListener('mouseout', this.handleOptionUnhover);
        }
        if (this.multiple) {
            // Initialize selectedValues from the value prop
            if (this.value && Array.isArray(this.value)) {
                this.selectedValues = [...this.value];
            }
            else if (this.value && typeof this.value === 'string') {
                try {
                    this.selectedValues = JSON.parse(this.value);
                }
                catch (_c) {
                    this.selectedValues = [];
                }
            }
            else {
                this.selectedValues = [];
            }
            // Ensure value is always an array for multiple checkboxes
            this.value = this.selectedValues;
            // Use a longer timeout to ensure DOM is ready and options are loaded
            setTimeout(() => {
                this.updateCheckboxStates();
            }, 150);
        }
    }
    updateCheckboxStates() {
        var _a;
        const checkboxes = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelectorAll('input[type="checkbox"]');
        checkboxes === null || checkboxes === void 0 ? void 0 : checkboxes.forEach(checkbox => {
            const shouldBeChecked = this.isChecked(checkbox.value);
            checkbox.checked = shouldBeChecked;
        });
    }
    valueChanged(oldValue, newValue) {
        if (this.multiple && Array.isArray(newValue)) {
            this.selectedValues = [...newValue];
            // Force checkbox states to update based on selectedValues
            setTimeout(() => {
                var _a;
                const checkboxes = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelectorAll('input[type="checkbox"]');
                checkboxes === null || checkboxes === void 0 ? void 0 : checkboxes.forEach(checkbox => {
                    const shouldBeChecked = this.isChecked(checkbox.value);
                    if (checkbox.checked !== shouldBeChecked) {
                        checkbox.checked = shouldBeChecked;
                    }
                });
            }, 10);
        }
        else if (this.multiple && typeof newValue === 'string') {
            // Handle string value for multiple checkboxes
            try {
                const parsed = JSON.parse(newValue);
                if (Array.isArray(parsed)) {
                    this.selectedValues = parsed;
                }
            }
            catch (_a) {
                this.selectedValues = [];
            }
        }
    }
    triggerChangeEvent() {
        _part_includes_1.handlePartChange.call(this, {
            target: {
                name: this.name,
                value: this.selectedValues
            }
        });
        // Also dispatch standard "change" event for broader compatibility
        this.$emit('change', {
            value: this.selectedValues,
            name: this.name,
            formPartType: CheckboxPart_1.PART_TYPE
        });
    }
    isChecked(value) {
        if (this.multiple) {
            const checked = this.selectedValues.includes(value);
            return checked;
        }
        return false;
    }
    getElement() {
        return this.$('input');
    }
    reset() {
        var _a;
        if (this.multiple) {
            this.selectedValues = [];
            this.value = [];
            const checkboxes = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelectorAll('input[type="checkbox"]');
            checkboxes === null || checkboxes === void 0 ? void 0 : checkboxes.forEach(cb => cb.checked = false);
        }
        else {
            this.$('input').checked = false;
            this.value = false;
        }
    }
};
exports.CheckboxPart = CheckboxPart;
CheckboxPart.PART_TYPE = 'checkbox';
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], CheckboxPart.prototype, "label", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], CheckboxPart.prototype, "name", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Object)
], CheckboxPart.prototype, "value", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", Boolean)
], CheckboxPart.prototype, "multiple", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", Number)
], CheckboxPart.prototype, "size", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", typeof (_a = typeof Array !== "undefined" && Array) === "function" ? _a : Object)
], CheckboxPart.prototype, "options", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], CheckboxPart.prototype, "horizontal", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], CheckboxPart.prototype, "ignored", void 0);
__decorate([
    (0, client_1.attr)({ mode: 'boolean' }),
    __metadata("design:type", Boolean)
], CheckboxPart.prototype, "dontEmit", void 0);
__decorate([
    (0, client_1.attr)({ mode: 'boolean' }),
    __metadata("design:type", Boolean)
], CheckboxPart.prototype, "inline", void 0);
__decorate([
    (0, client_1.attr)({ mode: 'boolean' }),
    __metadata("design:type", Boolean)
], CheckboxPart.prototype, "grid", void 0);
__decorate([
    (0, client_1.attr)({ mode: 'boolean' }),
    __metadata("design:type", Boolean)
], CheckboxPart.prototype, "hoverevent", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], CheckboxPart.prototype, "selectedValues", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Function)
], CheckboxPart.prototype, "onChange", void 0);
exports.CheckboxPart = CheckboxPart = CheckboxPart_1 = __decorate([
    (0, client_1.RWSView)('part-checkbox', null, { template: rwsTemplate, styles, options: { shadowOptions } })
], CheckboxPart);
CheckboxPart.defineComponent();
